import { EmploymentStatus } from 'api/SmallLoanProgram/EmploymentsApi';

import { FIELD_SETTINGS } from './employmentInformationBlock.constants';
import { EmploymentFieldsSettings } from './employmentInformationBlock.types';

export const getPrimaryEmploymentFieldsSettings = (
  employmentStatus: EmploymentStatus,
  isFormDisabled: boolean,
): EmploymentFieldsSettings => {
  const settings: EmploymentFieldsSettings = JSON.parse(JSON.stringify(FIELD_SETTINGS));

  if (isFormDisabled) {
    settings.BusinessName.isDisabled = true;
    settings.Position.isDisabled = true;
    settings.HireDate.isDisabled = true;
  }

  if (employmentStatus === EmploymentStatus.EmployedW2) {
    settings.BusinessName.isDisabled = true;

    return settings;
  }

  if (employmentStatus === EmploymentStatus.SelfEmployed) {
    settings.Position.isVisible = false;

    return settings;
  }

  if (employmentStatus === EmploymentStatus.Other) {
    settings.BusinessName.label = 'Other Income Name';
    settings.BusinessName.isDisabled = true;
    settings.Position.isVisible = false;

    return settings;
  }

  settings.BusinessName.isVisible = false;
  settings.Position.isVisible = false;

  return settings;
};

export const getPreviousEmploymentFieldsSettings = (isFormDisabled: boolean): EmploymentFieldsSettings => {
  const settings: EmploymentFieldsSettings = JSON.parse(JSON.stringify(FIELD_SETTINGS));

  if (isFormDisabled) {
    settings.BusinessName.isDisabled = true;
    settings.Position.isDisabled = true;
    settings.HireDate.isDisabled = true;
  }

  return settings;
};
